import React from 'react'
import style from './style.module.less'

// 上移、下移、删除、复制悬浮框
export default ({
  index,
  maxLength,
  onMoveUp,
  onMoveDown,
  onCopy,
  onReplace,
  onDelete
}) => (
  <div className={style.image_operate}>
    {onMoveUp && (
      <span
        className={`${style.image_operate__item} ${
          index == 0 ? style.up : style.up_active
        }`}
        onClick={onMoveUp}
      />
    )}
    {onMoveDown && (
      <span
        className={`${style.image_operate__item} ${
          index == maxLength - 1 ? style.down : style.down_active
        }`}
        onClick={onMoveDown}
      />
    )}
    {/* {onCopy && (
      <span
        className={`${style.image_operate__item} ${
          style.copy
        } iconfont icon-fuzhi`}
        onClick={onCopy}
      />
    )} */}
    {onDelete && (
      <span
        className={`${style.image_operate__item} ${style.remove}`}
        onClick={onDelete}
      />
    )}
  </div>
)
